import { render } from "./AnsweredCard.vue?vue&type=template&id=35a9e09e"
import script from "./AnsweredCard.vue?vue&type=script&lang=js"
export * from "./AnsweredCard.vue?vue&type=script&lang=js"
script.render = render

export default script